import { Button, Form, Input, Modal } from "antd";
import { useEffect, useState } from "react";
import { getData, postData, putData } from "../../utils";
import { errorMsg } from "../../utils/errorMsg";
import { useNotification } from "../../context/NotificationProvider";
import { useLoaderProvider } from "../../context/LoaderProvider";
import validateDomain from "../../utils/validateDomain";
const AddInstitutes = ({ isOpen = false, onCancel = () => {}, editId = 0, callback = () => {} }) => {
  const [form] = Form.useForm();
  const { openNotification } = useNotification();
  const { updateLoader } = useLoaderProvider();
  const [isDisabled, setIsDisabled] = useState(true);
  const [payload, setPayload] = useState({
    name: "",
    domain: "",
    usageNumber: 0,
  });

  const getEditRecord = async () => {
    updateLoader(true);
    try {
      let res = await getData(`/v1/admin/institution/get-single-institution-record/${editId}`);
      let data = res.data;
      form.setFieldsValue({
        name: data.name,
        domain: data.domain,
        usageNumber: data.usage_number,
      });
    } catch (e) {}
    updateLoader(false);
  };

  useEffect(() => {
    if (editId !== 0) {
      getEditRecord();
    } else {
      setPayload({
        name: "",
        domain: "",
        usageNumber: 0,
      });
    }
  }, [editId]);

  useEffect(() => {
    if (isNaN(payload.usageNumber)) {
      setIsDisabled(true);
    } else if (payload.name && validateDomain(payload.domain) && payload.domain && payload.usageNumber) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [payload]);

  const submit = async () => {
    updateLoader(true);
    let body = JSON.stringify(payload);
    if (editId === 0) {
      try {
        let s = await postData("/v1/admin/institution/add", body);
        openNotification(s.message);
        callback();
      } catch (e) {
        let d = errorMsg(e);
        openNotification(d.message);
      }
    } else {
      try {
        let s = await putData(`/v1/admin/institution/update/${editId}`, body);
        openNotification(s.message);
        callback();
      } catch (e) {
        let d = errorMsg(e);
        openNotification(d.message);
      }
    }
    updateLoader(false);
  };

  return (
    <>
      <Modal
        title={`${editId === 0 ? "Add" : "Edit"} Institute`}
        centered
        open={isOpen}
        onCancel={onCancel}
        footer={null}
      >
        <Form
          name="form"
          form={form}
          layout="vertical"
          initialValues={payload}
          onValuesChange={(changesValue, allValue) => {
            setPayload((prev) => ({ ...prev, ...allValue }));
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <Form.Item
            label="Institute name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter your Institute name",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Institute domain"
            name="domain"
            rules={[
              {
                required: true,
                message: "Please enter your Institute domain",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            label="Number of users"
            name="usageNumber"
            rules={[
              {
                required: true,
                message: "Please enter the usage number",
              },
              { pattern: /[0-9]$/, message: "Only numbers" },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <div className="flex justify-end">
            <Button type="primary" disabled={isDisabled} htmlType="submit" onClick={submit}>
              {editId === 0 ? "Add" : "Edit"}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddInstitutes;
